export default {
  "header": {
    "profile": "حِسَاب",
    "loginButton": "تسجيل الدخول",
    "registrationBtn": "التسجيل",
    "feedback": "تعليقات",
    "language": "اللغة",
    "darkTheme": "الوضع المظلم",
    "languageToggle": {
      "en": "الإنجليزية",
      "ru": "الروسية",
      "cn": "الصينية",
      "tr": "التركية",
      "es": "الإسبانية",
      "hi": "الهندية"
    }
  },
  "profileNavMenu": {
    "goToProfile": "الملف الشخصي",
    "activeNumber": "الأرقام المستلمة",
    "queryStatistics": "إحصائيات الاستعلام",
    "balanceHistory": "سجل الرصيد",
    "tariffs": "التعريفات",
    "settings": "الإعدادات",
    "balance": "الرصيد",
    "topupBalance": "رصيد إعادة الشحن",
    "topupAlert": "",
    "logout": "تسجيل الخروج",
    "referralProgram": "برنامج الإحالة",
    "saleAgreement": "بيع التراخيص",
    "software": "برنامج",
  },
  "profile": {
    "activeNumbers": {
      "title": "الأرقام المستلمة",
      "noActiveNumbers": "لا توجد أرقام نشطة",
      "serverError": "خطأ في الخادم",
      "status": "الحالة",
      "waitingForSms": "في انتظار الرسالة القصيرة",
      "time": "الوقت",
      "banned": "محظور؟",
      "cancel": "إلغاء",
      "message": "تم قبول الرمز ودفع ثمنه. يرجى إدخال الرمز",
      "messageMultipleSms": "خلال الوقت المتبقي، يمكنك الحصول على رموز جديدة من الخدمة مجانًا",
      "blockModalMessage1": "هل تم حظر هذا الرقم من قبل الخدمة؟<br /> أخبرنا بذلك وسنقوم بإزالته من نتائج البحث",
      "blockModalMessage2": "سيتم إرجاع الأموال إلى الرصيد فورًا.<br /> حاول شراء رقم جديد في نفس الدولة أو أخرى.",
      "blockBtn": "نعم، الرقم محظور",
      "moreSms": "المزيد من الرسائل",
      "availableIn": "متاح خلال: ",
      "waitingSms": "في انتظار رسائل جديدة",
      "getNewNumber": "احصل على رقم جديد"
    },
    "queryStatistics": {
      "title": "إحصائيات الاستعلام",
      "noQuery": "لا يوجد استعلام",
      "buyFor": "شراء مقابل"
    },
    "balanceHistory": {
      "title": "سجل الرصيد",
      "outgoing": "الصادر",
      "incoming": "الواردة",
      "showMore": "عرض المزيد",
      "noHistory": "لا يوجد سجل",
      "numberOrder": "الدفع مقابل الفاتورة №"
    },
    "tariffs": {
      "title": "التعريفات"
    },
    "settings": {
      "title": "الإعدادات",
      "sound": "تشغيل الصوت عند استلام الرمز",
      "infoAboutServices": "عرض معلومات عن المشتريات النشطة",
      "twoFactorEnabled": "المصادقة الثنائية",
      "infoAboutBalance": "حد أدنى للرصيد لإشعارات البريد الإلكتروني",
      "apiKey": "مفتاح API",
      "message": "قم بإنشاء مفتاح API للتفاعل مع الموقع باستخدام البروتوكول",
      "buttonUpdate": "تحديث مفتاح API",
      "updateError": "خطأ في التحديث",
      "settingsChanged": "تم تغيير الإعدادات",
      "errorChangingSettings": "خطأ في تغيير الإعدادات",
      "phoneNumber": "رقم هاتفك",
      "playceholderPhone": "أدخل رقمك",
      "refParams": {
        "refLink": "تقرير برنامج الإحالة:",
        "refOptions": "خيارات برنامج الإحالة:"
      }
    },
    "myPersonalInformation": {
      "title": "بياناتك الشخصية",
      "yourEmail": "بريدك الإلكتروني",
      "yourName": "اسمك"
    },
    "referralProgram": {
      "accruals": "الاستحقاقات",
      "referrals": "الإحالات",
      "transaction": "المعاملة",
      "paymentType": "نوع الدفع",
      "paymentHistory": "سجل الدفع",
      "withdrawFunds": "سحب الأموال",
      "referralLinks": "روابط الإحالة",
      "referralLinksMobile": "روابط الإحالة",
      "existingLinks": "الروابط الحالية",
      "availableOutput": "متاح للسحب",
      "сreateAnotherLink": "إنشاء رابط آخر",
      "createReferralLink": "إنشاء رابط إحالة جديد",
      "submitWithdrawalRequest": "تقديم طلب سحب",
      "successCreateReferralLink": "تم إنشاء رابط الإحالة بنجاح",
      "referralLinksEmpty": "انقر على الزر أدناه لإنشاء واحد.",
      "title": "برنامج الإحالة",
      "referralLinkTitle": "رابط الإحالة",
      "buttonCopy": "نسخ",
      "buttonDownload": "تحميل",
      "topUpAmount": "المبلغ المنفق من قبل إحالاتك",
      "youHaveAlreadyReceived": "تم استلام مدفوعات الإحالة",
      "awaiting": "الرصيد المتبقي من الإحالات",
      "derived": "منها - مشتقة",
      "detailing": "تقرير نظام الإحالة",
      "formTitle": "إرسال طلب",
      "formButton": "طلب السحب",
      "participatePromotion": "المشاركة في الترويج",
      "earnedYourReferrals": "المكاسب من إحالاتك",
      "instructions": "أرسل رابط التسجيل هذا إلى صديق أو استخدمه لتحويل الزيارات. يمكنك سعمولة الإحالة (5% من حجم الإحالات) بأي طريقة مناسبة. يمكن إنفاق الأموال المتراكمة على شراء الأرقام أو سحبها إلى بطاقة أو محفظة إلكترونية. السحب إلى محفظة تشفيرية: من 100 USDT، إلى بطاقة: من 5000 ₽.",
      "user": "المستخدم",
      "developer": "المطور"
    }
  },
  "profilePay": {
    "sectionBalanceReplenishment": {
      "title": "إعادة تعبئة الرصيد",
      "cardButtonSelect": "اختر",
      "paymentTitle": "الدفع",
      "paymentMessage": "قم بالدفع دائمًا من خلال واجهة الموقع بالضغط على زر \"ادفع\"، فقط حينها سيتم تحويل الأموال إلى الحسابات الصحيحة",
      "paymentMessageAlipay": "الخدمة مدعومة فقط للمستخدمين المُتحققين في الصين القارية. يمكنك تجربة طريقة لجميع مستخدمي AliPay أدناه.",
      "paymentPlaceholder": "أدخل المبلغ *",
      "paymentButton": "ادفع",
      "paymentErrorAmount": "يجب أن يكون مبلغ الإعادة أكبر من 0",
      "payComment": "عمولة التعبئة",
      "plasticCard": "البطاقات المصرفية: روسيا فقط",
      "minAmount": "الحد الأدنى للمبلغ المدفوع {minPrice} ₽",
      "minAmountMessage": "الحد الأدنى للمبلغ المدفوع {minPrice} ₽",
      "payMessageForPayeer": "طريقة الدفع المختارة، خدمات grizzlysms.com مقدمة من THREE TWO TWO LTD. للمتابعة، يجب الموافقة على الوثائق المذكورة أدناه.",
      "payMessageForPaypalych": "البطاقات المصرفية: روسيا فقط 🇷🇺 (بديل)",
      "som": "البطاقات المصرفية: عالميًا - الطريقة №2",
      "payMessageForNut": "البطاقات المصرفية: عالميًا - الطريقة №3",
      "stripe": "البطاقات المصرفية: عالميًا - الطريقة №1 (رايا)",
      "bankCardsTemplateRussia": "البطاقات المصرفية: روسيا فقط 🇷🇺",
      "payMessageForTether": "هام: قم بتحويل المبلغ المحدد بدقة من قبل نظام الدفع. وإلا لن يتم إضافة الأموال وسيكلف الاسترداد 10.",
      "alipayTitle": "للدفع عبر AliPay، امسح رمز QR:",
      "alipayText": "...وأرسل لنا بريدك الإلكتروني المسجل وصورة الدفع إلى الدردشة المباشرة (↘).<br/>لا يمكن إعادة شحن رصيدك تلقائيًا. يرجى مراسلتنا.<br/>الحد الأدنى للدفع: 10 RMB.",
      "paymentMessageForConvertor": "المبلغ المطلوب دفعه، {currency}:",
      "paymentMessageForConvertorWithCommission": "المبلغ المطلوب دفعه شامل العمولة، {currency}:",
      "willBeCredited": "سيتم إضافة، {currency}:",
      "messageForConverterDollars": "نقبل الدولارات ونحولها إلى روبل بسعر: <span> {rate} </span> ₽ للدولار.",
      "getNumbersFor": "الحصول على رقم لـ {name}",
      "usdHelpMessage": "المعلومات للإرشاد. اعتبر المبلغ المذكور في واجهة الدفع كأولوية. بسبب تقلبات سعر الصرف، قد تختلف المبالغ قليلاً."
    },
    "aliPay": {
      "title": "AliPay وQQpayments",
      "messageStep1": "1. انتقل إلى الرابط أدناه، اختر المبلغ وادفعه:",
      "messageStep2": "2. أدخل رمز الدفع لإضافة أموال إلى رصيد Grizzly SMS:",
      "send": "إرسال",
      "couponNotFound": "القسيمة غير موجودة",
      "placeholderPassword": "أدخل الرمز للإضافة",
      "waitingForRedirectPayment": "انتظر الانتقال إلى الموقع لإتمام الدفع",
      "paymentCodeNotCorrect": "رمز الدفع غير صحيح",
      "buttonGetLink": "ادفع عبر AliPay أو QQ احصل على رمز"
    },
    "cryptoPayments": {
      "label": "المدفوعات التشفيرية"
    },
    "notifications": {
      "proceed_payment_title": "لننتقل إلى الدفع...",
      "proceed_payment_message": "من فضلك لا تغلق الصفحة"
    },
  },
  "servicesList": {
    "Выбор_страны": "اختيار الدولة",
    "Выбор_страны_для": "اختيار الدولة لـ {name}",
    "title": "اختر الدولة",
    "titlePopular": "الدول الشائعة",
    "chooseAnother": "اختر أخرى",
    "countryInputPlaceholder": "اختر الدولة",
    "selectedLable": "اختيار",
    "searchInputPlaceholder": "بحث الخدمة",
    "buttonWaiting": "جاري الانتظار...",
    "buttonBuy": "احصل على",
    "buttonRent": "استئجار",
    "message": "لا توجد أرقام متاحة حاليًا للدولة المختارة",
    "buttonUpdate": "تحديث",
    "quantity": "الكمية",
    "quantityFew": "قليل",
    "numberTemporarilyUnavailable": "متاح فقط عبر API",
    "orderFrom100numbers": "اطلب من 100 رقم عبر خدمة الدعم",
    "labelCountryHighPercentDelivery": "دول بنسبة توصيل عالية",
    "labelSelectOtherCountry": "اختر دولة أخرى",
    "showMore": "عرض المزيد",
    "from": "من",
    "retail": "تجزئة",
    "authRetail": "سعرك",
    "wholesale": "جملة",
    "getItFor": "احصل عليه مقابل",
    "telegramMessagePrice": "معلومات أسعار الجملة:",
    "telegramMessageBot": "تطبيق Telegram Mini:",
    "telegramMessageNews": "أخبار الخدمة:",
    "scrollBtn": "جميع الخدمات والدول",
    "selectCountry": "اختر الدولة",
    "selectService": "اختر الخدمة",
    "relatedArticlesFor": "مقالات حول موضوع «{name}»",
    "requestNewServiceForm": {
      "title": "اقترح خدمة",
      "subTitle": "لم تجد الخدمة المناسبة؟ أخبرنا المزيد وسنحل الأمر. <br /> يمكنك حاليًا استخدام القسم",
      "anyother": "أخرى",
      "dataAboutSite": "عنوان الموقع *",
      "smsMessage": "نص الرسالة *",
      "countryService": "الدولة المطلوبة (اختياري)",
      "price": "سعر الرقم (اختياري)",
      "btnSend": "إرسال",
      "backToList": "العودة إلى القائمة",
      "offerServiceBtn": "اقترح خدمة"
    },
    "linkToAccount": {
      "btnMsg": "حسابات {accountName}",
      "text": "* العمل مع حسابات {accountName} الجاهزة يتطلب معرفة بالحاسوب؛ مجموعة الدول المتاحة تختلف عن تلك الخاصة بالتسجيل الذاتي."
    }
  },
  "languagesList": {
    "Выбор_сервиса": "اختيار الخدمة",
    "Поиск_по_сервисам": "بحث بالخدمات",
    "Выберите_услугу": "اختر خدمة",
    "Поиск_по_странам": "بحث بالدول",
    "Успешная_покупка_номера": "تم شراء الرقم بنجاح. سيظهر قريبًا في \"الأرقام المستلمة\"",
    "serviceNotFound": "الخدمة غير موجودة",
    "repeatMsg": "انتظر < {min} دقيقة",
    "repeatModal": {
      "attempt": "المحاولة",
      "from": "من",
      "Долгое_ожидание": "انتظار طويل؟",
      "Предложение_ускорить_поиск": "لنحاول العثور على غرفة بسعر أعلى. سيتم خصم الأموال فقط بعد استلام الرسالة. يمكنك دائمًا إلغاء الرقم أو عدم إدخاله في طلب الخدمة. كلما زاد السعر الإضافي، زادت فرصة العثور بسرعة.",
      "lowBalanceMessage": "رصيد غير كافٍ"
    },
    "errorMessages": {
      "NO_NUMBERS": "الرقم غير متاح. حاول مرة أخرى",
      "abort": "تم إيقاف البحث عن الأرقام"
    }
  },
  "blog": {
    "title": "المدونة",
    "buttonDetails": "المزيد",
    "pageNumber": "الصفحة №",
    "tags": "العلامات",
    "recentPost": "منشور حديث",
    "readMore": "مقالات مشابهة",
    "getNumberFor": "احصل على رقم لـ"
  },
  "footer": {
    "title": "أفضل خدمة لاستلام الرسائل القصيرة عبر الإنترنت",
    "userAgreement": "اتفاقية المستخدم",
    "referralProgram": "برنامج الإحالة",
    "returnsPolicy": "سياسة الإرجاع",
    "personalInformation": "المعلومات الشخصية",
    "messageDisabledRussianNumbers": "أرقام الهواتف الروسية غير متاحة للبيع",
    "footerDisabledRussianNumbers": "لا يتم توفير أرقام المشتركين الروس للاستخدام المؤقت بسبب متطلبات القانون الفيدرالي \"الاتصالات\" بتاريخ 07.07.2003 N 126-FZ."
  },
  "registration": {
    "title": "التسجيل",
    "registrationSuccessMessage": "تم تسجيل المستخدم بنجاح! <br/> تم إرسال رابط تأكيد التسجيل إلى البريد",
    "nameInputPlaceholder": "الاسم *",
    "emailInputPlaceholder": "البريد الإلكتروني *",
    "passwordInputPlaceholder": "كلمة المرور *",
    "passwordConfirmInputPlaceholder": "تأكيد كلمة المرور *",
    "buttonRegistration": "التسجيل",
    "buttonRegistrating": "جاري الانتظار...",
    "passwordsMismatchMessage": "عدم تطابق كلمات المرور",
    "backHome": "العودة للصفحة الرئيسية",
    "loginWithSocialNetworks": "تسجيل الدخول عبر الشبكات الاجتماعية:",
    "orRegistrartion": "أو سجل",
    "iAgree": "أوافق على",
    "privacyPolicy": "البيانات الشخصية وسياسة الكوكيز",
    "userAgreement": "العرض العام",
    "alreadyHaveAccount": "هل لديك حساب بالفعل؟",
    "login": "تسجيل الدخول",
    "messageSuccessConfirmRegistration": "تم تأكيد التسجيل بنجاح"
  },
  "authorization": {
    "title": "التسجيل",
    "emailInputPlaceholder": "البريد الإلكتروني",
    "passwordInputPlaceholder": "كلمة المرور",
    "tokenInputPlaceholder": "الرمز",
    "buttonRegistration": "تسجيل الدخول",
    "buttonRegistrating": "جاري الانتظار...",
    "or": "أو",
    "newUser": "مستخدم جديد؟",
    "registration": "التسجيل",
    "forgotPassword": "نسيت كلمة المرور؟"
  },
  "resetThePassword": {
    "title": "إعادة تعيين كلمة المرور",
    "buttonReset": "إعادة التعيين",
    "buttonWaiting": "جاري الانتظار...",
    "emailInputPlaceholder": "البريد الإلكتروني",
    "message": "تم إرسال رابط إعادة تعيين كلمة المرور إلى بريدك. يرجى التحقق من صندوق الوارد واتباع التعليمات."
  },
  "errorsValidationForms": {
    "requiredForFill": "مطلوب تعبئته",
    "emailErrorMessage": "بريد إلكتروني غير صالح",
    "requaredLengthMessage": "الحد الأدنى للأحرف:"
  },
  "advantagesBlock": {
    "title": "مزايانا"
  },
  "aboutBlock": {
    "showMoreBtn": "المزيد",
    "rollUp": "طي"
  },
  "serviceCard": {
    "availableNumbers": "الأرقام المتاحة",
    "price": "السعر",
    "buyNow": "اشتري الآن",
    "emptyCountryListMessage": "لا توجد أرقام متاحة للخدمة المختارة.<br /> يرجى المحاولة لاحقًا"
  },
  "feedbackForm": {
    "title": "تعليقات",
    "namePlaceholder": "الاسم *",
    "emailPlaceholder": "البريد الإلكتروني *",
    "messagePlaceholder": "الرسالة *",
    "iAgree": "أوافق على",
    "privacyPolicy": "البيانات الشخصية وسياسة الكوكيز",
    "userAgreement": "العرض العام",
    "buttonSend": "إرسال",
    "buttonRegistrating": "جاري الانتظار...",
    "sendError": "خطأ في الإرسال",
    "applicationIsAccepted": "تم قبول طلبك"
  },
  "copyToBuffer": {
    "success": "تم النسخ بنجاح",
    "error": "خطأ في النسخ"
  },
  "breadcrumbs": {
    "homePage": "الصفحة الرئيسية",
    "blog": "المدونة"
  },
  "confirm": {
    "passwordReset": "إعادة تعيين كلمة المرور",
    "newPassword": "كلمة المرور الجديدة",
    "confirmPassword": "تأكيد كلمة المرور",
    "confirm": "تأكيد",
    "authorization": "التسجيل",
    "notMatch": "كلمة المرور غير متطابقة",
    "changedSuccessfully": "تم تغيير كلمة المرور بنجاح"
  },
  "errorPage": {
    "pageNotFound": "الصفحة غير موجودة",
    "somethingWentWrong": "حدث خطأ ما",
    "backHomepage": "العودة للصفحة الرئيسية"
  },
  "support": {
    "inputSearch": {
      "placeholder": "اكتب سؤالك"
    }
  },
  "successPayment": {
    "successMsg": "تم الدفع بنجاح",
    "waitMsg": "جاري المعالجة",
    "backHomepage": "العودة للصفحة الرئيسية"
  },
  "searchPage": {
    "placeholder": "بحث...",
    "showMore": "عرض المزيد",
    "nothingFoundMsg": "لم يتم العثور على نتائج",
    "Сервисы": "الخدمات",
    "Статьи": "المقالات",
    "Страницы": "الصفحات",
    "Все результаты": "جميع النتائج",
    "apiHeaders": {
      "service": {
        "service": 'الخدمات',
        "serviceCode": 'كود الخدمة'
      },
      "country": {
        "country": 'البلد',
        "countryCode": 'رمز البلد'
      }
    }
  },
  "common": {
    "accept": "قبول",
    "downloadFile": "تحميل الملف",
    "temporarily_unavailable": "غير متاح مؤقتًا",
    "weUseCookies": "نستخدم الكوكيز لتحليل تفاعل الزوار مع الموقع. باستمرارك في استخدام «Gryzzly SMS»، أنت توافق على استخدام الكوكيز."
  },
  "lastArticlesBlock": {
    "title": "المدونة",
    "textBtn": "مدونتنا"
  },
  "reviewsBlock": {
    "title": "آراء العملاء عنا",
    "addReviewBtn": "أضف مراجعة",
    "yourName": "اسمك",
    "messageTextarea": "أضف رأيك",
    "sendReview": "إرسال المراجعة",
    "success": "تم إرسال المراجعة بنجاح",
    "validNameMsg": "أدخل اسمك",
    "validMsg": "أدخل مراجعتك"
  },
  "currencyToggle": {
    "tooltipCurrency": "الأسعار بالدولار للإرشاد. تتم المعاملات بالروبل فقط."
  },
  "pagination": {
    "showing": "عرض",
    "of": "من"
  },
  "additionalCashbackAccrual": {
    "message": "<span>+10%</span> استرداد نقدي لرصيدك عند <span>1st</span> إعادة شحن من <span>{{balance}}</span>!",
    "buttonCancel": "لا، شكرًا",
    "buttonPayment": "إعادة شحن الرصيد"
  },
  "countries": {
    "title": "قائمة الدول المتاحة",
    "countries": "الدول",
    "popularServices": "الخدمات الشائعة",
    "anotherServices": "اختر خدمة"
  },
  "botLinkPage": {
    "question": "هل أنت متأكد من رغبتك في ربط الملف الشخصي {userName} بحسابك على موقع Grizzly SMS؟",
    "ok": "نعم",
    "cancel": "إلغاء",
    "success": "تم ربط حساب التليجرام بنجاح",
    "alreadyHaveBot": "تم ربط حساب Telegram بالفعل بحسابك في Grizzly SMS."
  },
  "errors": {
    "err1": "حدث خطأ. يرجى المحاولة لاحقًا.",
    max_amount_conclusion: 'الحد الأقصى للمبلغ المسحوب "{balance}"',
    invalid_number_credit_card: "رقم البطاقة غير صالح",
    error_ru_bank_credit_card: "السحب على هذه البطاقة غير متاح. يرجى إدخال رقم بطاقة روسية."
  },
  "partnerPage": {
    "becomePartner": "كن شريكًا",
    "historyAccruals": "سجل الاستحقاقات",
    "popUp": {
      "title": "كن شريكًا",
      "yourContactPlaceholder": "معلومات الاتصال (تليجرام، WeChat، واتساب، بريد إلكتروني، إلخ)",
      "countryPlaceholder": "دول بطاقات SIM",
      "equipmentPlaceholder": "معداتك",
      "equipmentPortsPlaceholder": "عدد المنافذ",
      "aboutPlaceholder": "معلومات إضافية عنك",
      "send": "إرسال",
      "accept1": "أوافق على",
      "accept2": "سياسة الخصوصية واستخدام البيانات",
      "errorForm": "حدث خطأ، حاول مرة أخرى",
      "successForm": "تم إرسال الطلب بنجاح"
    }
  },
  "partnerFormBlock": {
    "title": "كن شريكًا",
    "contactTitle": "التليجرام",
    "contactPlaceholder": "طريقة الاتصال المفضلة",
    "countrySimCard": "دول أرقام الهواتف",
    "countrySimCardPlaceholder": "مفصولة بفواصل",
    "yourEquipment": "مودمات GSM",
    "yourEquipmentPlaceholder": "وصف مفصل",
    "countPort": "عدد المنافذ (16 أو أكثر)",
    "countPortPlaceholder": "رقم",
    "message": "معلومات إضافية عنك",
    "messagePlaceholder": "صف عملك بالتفصيل",
    "accountGrizzlySmsEmail": "حساب Grizzly SMS (البريد الإلكتروني)"
  },
  "partnerHeadingBlock": {
    "becomePartner": "كن شريكًا",
    "yieldCalculator": "حاسبة الأرباح"
  },
  "partnerCalculatorBlock": {
    "country": "الدولة",
    "priceSim": "سعر بطاقة SIM",
    "countPort": "عدد المنافذ",
    "netProfit": "صافي الربح",
    "netProfit3": "الربح خلال 3 أشهر",
    "netProfit6": "الدخل خلال 6 أشهر",
    "netProfit12": "الدخل خلال 12 شهرًا"
  },
  "generalSearch": {
    "searchByCountry": "البحث بالدولة",
    "searchByService": "البحث بالخدمة",
    searchByCountryMobile: "حسب البلد",
    searchByServiceMobile: "حسب الخدمة",
    "title": "أسعار الأرقام الافتراضية لاستلام SMS",
    "subtitle": "اختر الخدمة أو الدولة من الجدول أدناه",
    "tableHeaderRatio": "رقم الإصدار",
    tableHeaderRatioMobile: "إصدار",
    "tableHeaderService": "الخدمة",
    "tableHeaderCountry": "الدولة",
    "tableHeaderCurrency": "سعر الجملة",
    "tableHeaderAmount": "الكمية",
    "tableHeaderNumberReceived": "% الرقم",
    "tableHeaderSmsReceived": "% الرسائل",
    "tableHeaderActivation": "التفعيل",

    "tableShowMoreButton": {
      "services": 'عرض جميع الخدمات',
      "countries": 'عرض جميع البلدان',
    },
    "tableShowLessButton": {
      "services": 'الخدمات الشعبية',
      "countries": 'البلدان الشعبية',
    },
    "ratioLabel": {
      "low": "منخفض",
      "medium": "متوسطة",
      "high": "عالية"
    },
  },
  "profileLoyaltyProgram": {
    "cashback": {
      "title": "استرداد نقدي",
      "week_deposit": "مبلغ الإيداع الأسبوعي",
      "projectedCashback": "الاسترداد المتوقع",
      "tillNextRank": "حتى الرتبة التالية",
      "cashbackPercentNextRank": "نسبة الاسترداد في الرتبة التالية",
      "rang": "الرتبة"
    },
    "history": {
      "title": "سجل المشاركة",
      "message1": "لإعادة الشحن",
      "message2": "تم استحقاق الاسترداد"
    },
    "programConditions": {
      "title": "شروط برنامج الولاء",
      "rangLeft": "الرتبة: شروط الحصول",
      "rangRight": "% الاسترداد",
      "rangNotLeft": "بدون رتبة: إيداعات > 0 <1,000 ₽",
      "rangNotRight": "لا استرداد",
      "message": "يتم استحقاق الاسترداد يوم <span>الاثنين</span> بناءً على إجمالي الإيداعات الأسبوع الماضي. النسبة تعتمد على الرتبة المحققة.",
      "replenishment": "إعادة الشحن",
      "cashback": "استرداد نقدي"
    }
  },
  "license": {
    "licenseSuccess": "تم شراء الترخيص وإرساله إلى بريدك",
    "buyKey": "شراء مفتاح من GrizzlySMS"
  },
  "featuresTextBlock": {
    "getIndividualNumber": "احصل على رقم خاص"
  },
  "sortComponent": {
    "country": "الدول الرئيسية"
  },
  "rentNumbers": {
    "typeViews": {
      "number_activation": "التفعيل",
      "rent_number": "الاستئجار",
      "readyAccounts": "الحسابات"
    },
    "rentInformation": {
      "rental_period": "فترة الاستئجار",
      "rental_duration": "مدة الاستئجار",
      "rent": "الاستئجار",
      "the_clock": "بالساعة",
      "for_days": "بالأيام",
      "specify_rental_duration": "حدد المدة",
      "maximum_number_hours": "الحد الأقصى (ساعات)",
      "minimal_number_hours": "الحد الأدنى (ساعات)",
      "number_successfully_rented": "تم الاستئجار بنجاح",
      "selected_time_not_available": "الرقم غير متاح",
      "available_minimum_rental_period": "الحد الأدنى للاستئجار",
      "available_maximum_rental_period": "الحد الأقصى للاستئجار"
    },
    "myRentNumbers": {
      "rent_virtual_number": "استئجار رقم افتراضي",
      "active": "نشط",
      "received": "مستلم",
      "returned": "ملغى",
      "not_found": "غير موجود"
    },
    "rentNumberCard": {
      "canceled": "ملغى",
      "expires_in": "ينتهي خلال",
      "extension": "تمديد",
      "messageTitle": "الرسائل",
      "messageMessage": "لم تصل رسائل أو مكالمات بعد. أرسل SMS أو اتصل، وستظهر المعلومات هنا.",
      "successCancel": "تم إلغاء الاستئجار بنجاح",
      "successNumberRenewal": "تم التمديد بنجاح",
      "rentalPeriodExpired": "منتهي الصلاحية"
    },
    "readyNumbers": {
      "message": "هام! إذا اشتريت حسابًا جاهزًا، راجع قسم <a href=\"{link}\">\"الحسابات\"</a> في صفحة الأسئلة الشائعة.",
      "ok": "موافق",
      "toFaq": "الأسئلة الشائعة",
      "cancel": "إلغاء"
    },
    "popUpExtendLease": {
      "extend_number_rental": "تمديد الاستئجار",
      "going_renew_lease_number": "هل تريد تجديد استئجار الرقم؟",
      "renewal_history": "سجل التمديد",
      "date": "التاريخ",
      "price": "السعر",
      "term_hours": "المدة (ساعات)",
      "number_rental_renewal_period": "فترة التمديد",
      "lease_successfully_extended_until": "تم التمديد حتى",
      "close": "إغلاق",
      "short_day": "يوم",
      "short_hours": "ساعة",
      "short_minutes": "دقيقة"
    },
    "helpPopUp": {
      "message": "<h4>تفعيل الرقم</h4>\n      <p>إذا لم تستلم SMS خلال 20 دقيقة، يمكنك إلغاء الرقم واسترداد الأموال.</p>\n\n      <h4>استئجار رقم</h4>\n      <p>خلال الفترة المختارة، يمكنك استلام عدد غير محدود من الرسائل.</p>\n      <p>يمكنك دائمًا استعادة الوصول إلى حسابك!</p>\n      <p>الحد الأدنى للاستئجار: 4 ساعات، الحد الأقصى: 4 أسابيع.</p>\n\n      <h4>الحسابات الجاهزة</h4>\n      <p>اشتري حسابات جاهزة لخدمات مثل Telegram وVK. اقرأ التفاصيل في الأسئلة الشائعة.</p>"
    }
  },
  "comments": {
    "add_comment": "أضف تعليقًا",
    "comments": "التعليقات",
    "collapse": "طي",
    "expand": "توسيع",
    "send_comment_moderation": "تم إرسال تعليقك للمراجعة.",
    "ony_auth_user": "للمستخدمين المسجلين فقط"
  },
  "saleAgreement": {
    "title": "بيع التراخيص",
    "name": "الاسم",
    "type_po": "نوع البرنامج",
    "price": "السعر",
    "date_purchase": "تاريخ الشراء"
  },
  "freeNumbersPopUpRegistration": {
    "subtitle": "لم يعمل التسجيل برقم مجاني؟ سجل واحصل على رقم خاص للخدمة - <span>من $0.01!</span>",
    "button": "جرب"
  },
  "accountShop": {
    "mainSectionInfo": {
      "my_paid_accounts_title": "حساباتي المدفوعة",
      "my_paid_accounts_message": "عرض الحسابات المشتراة ومعلومات الدخول",
      "my_paid_accounts_button": "شراء الحسابات",
      "purchasing_ready_accounts_title": "شراء الحسابات",
      "purchasing_ready_accounts_message": "اشتري حسابات جاهزة للخدمات الشهيرة.",
      "purchasing_ready_accounts_button": "حساباتي المدفوعة"
    },
    "selectedService": {
      "title": "اختر الخدمة",
      "search_placeholder": "بحث باسم الخدمة"
    },
    "selectedOffer": {
      "title": "اختر العرض"
    },
    "dialogOffer": {
      "title": "شراء حساب",
      "name_of_product": "اسم المنتج",
      "description_of_product": "وصف المنتج",
      "characteristics": "الخصائص",
      "registration_method": "طريقة التسجيل",
      "country": "الدولة",
      "account_format": "تنسيق الحساب",
      "availability_cloud_password": "كلمة مرور السحابة",
      "information_about_purchased_product": "معلومات المنتج",
      "download_files": "تحميل الملفات",
      "buy_more": "شراء المزيد",
      "yes": "نعم",
      "no": "لا",
      "minimum_order_quantity": "الحد الأدنى للطلب"
    },
    "myServices": {
      "messageAuth": "يجب تسجيل الدخول",
      "messageEmpty": "لا توجد حسابات مشتراة"
    }
  },
  "partner": {
    "breadcrumbs_title": "الشريك",
    "documentation": "الوثائق",
    "activations_history": {
      "activations_history": "سجل التفعيلات",
      "filter": "تصفية",
      "export_in": "تصدير إلى",
      "number": "الرقم",
      "load_more": "المزيد",
      "total_rows": "الإجمالي: {{ count }} صف",
      "select_status": "اختر الحالة",
      "date_activation": "تاريخ التفعيل",
      "date_from": "من تاريخ",
      "date_to": "إلى تاريخ",
      "ready": "جاهز",
      "canceled": "ملغى",
      "activation": "التفعيل"
    },
    "sim_card": {
      "sim_card": "بطاقة SIM",
      "port": "المنفذ",
      "info": "المعلومات",
      "earned": "المكاسب",
      "countServices": "عدد الخدمات"
    },
    "price_regulator": {
      "price_regulator": "منظم الأسعار",
      "select_country_started": "اختر دولة للبدء",
      "services": "الخدمات",
      "search_service": "بحث بالخدمة",
      "all_services": "جميع الخدمات",
      "all_countries": "جميع الدول",
      "popular_services": "شائعة",
      "market_price": "تعيين السعر",
      "competitors_prices": "أسعار المنافسين",
      "pice_successfully_changed": "تم تغيير السعر بنجاح"
    },
    "withdrawal_founds": {
      "bank_card_number": 'بطاقة روسية',
      "withdrawal_founds": "سحب الأموال",
      "convertationHelpMessage": "يتم تحويل الروبل الروسي وتثبيت الأرباح بالدولار الأمريكي يوميًا في الساعة 10:00 بتوقيت غرينتش عن آخر 24 ساعة. سعر الصرف الحالي للفترة المفتوحة هو: 1 دولار أمريكي = {rubValue} روبل روسي.",
      "balance": "رصيدك",
      "order_payments": "طلب سحب",
      "transfer_balance": "رصيد التحويل",
      "currency_type": "نوع العملة",
      "withdrawal_method": "طريقة السحب",
      "order_status": "حالة الطلب",
      "select_method": "اختر طريقة",
      "select_status": "اختر الحالة",
      "requisites": "البيانات",
      "sum": "المبلغ",
      "currency": "العملة",
      "date": "التاريخ",
      "status": "الحالة",
      "nothing_found": "لا يوجد نتائج",
      "amount_in_currency": "المبلغ بالعملة",
      "wallet_card_number": "رقم المحفظة/البطاقة",
      "comment": "تعليق",
      "not_necessary_placeholder": "اختياري",
      "all_btn": "الكل",
      "error_required": "املأ الحقول المطلوبة",
      "success_msg": "تم قبول طلبك",
      "select_currency_type": "اختر العملة",
      "warning_message": "<span>هام!</span> تأكد من صحة بيانات الدفع. لا نتحمل مسؤولية الأخطاء.",
      "notification_message": "سيتم تحويل المبلغ المحدد إلى رصيدك الرئيسي في الرسائل القصيرة أشيب.",
      "error_ru_bank_card": "السحب على هذه البطاقة غير متوفر. يرجى إدخال رقم بطاقة روسية"
    },
    "statistic": {
      "statistic": "إحصائيات الربح",
      "average_SIM": "المتوسط <br/> لكل SIM",
      "top_services": "أفضل الخدمات <br/>خلال 24 ساعة",
      "activations_count": "عدد التفعيلات <br />خلال 24 ساعة",
      "last_24_hours": "آخر <br />24 ساعة"
    },
    "dialog_competitors_prices": {
      "your_price": "سعرك",
      "competitors_prices": "أسعار المنافسين"
    }
  },
  "newPayments": {
    "minAmount": "الحد الأدنى للدفع:",
    "commission": "العمولة:",
    "messageNumberInternationalFormat": "أدخل رقم هاتفك بالتنسيق الدولي"
  },
  "soft": {
    "submit_application": "تقديم طلب",
    "search_by_name": "بحث بالاسم",
    "all_services": "جميع<br/>الخدمات",
    "activations": "التفعيلات"
  },
  "productLicensesBlock": {
    "availableAt": "متاح على"
  },
  "documentationApi": {
    "rent": "API الاستئجار",
    "tables": "الجداول",
    "activations": "تفعيل API",
    "expandContent": "توسيع المحتوى",
    "collapseContent": "طي المحتوى",
    "successLinkCopy": "تم النسخ بنجاح",
    "successApiKeyCopy": "تم نسخ المفتاح بنجاح",
    "select": "اختر",
    "fillIn": "املأ",
    "result": "النتيجة",
    "execute": "تنفيذ",
    "urlRequest": "رابط الطلب",
    "resultLoading": "جاري التحميل...",
    "testMethodNow": "جرب هذه الطريقة الآن"
  },
  "marketplaceRegistrationPage": {
    "pageTitle": "تسجيل المتجر",
    "formInputs": {
      "name": {
        "label": "اختر اسمًا يعكس هوية متجرك",
        "placeholder": "الاسم",
        "errorMessage": "مطلوب"
      },
      "shopDescription": {
        "label": "وصف المتجر",
        "placeholder": "وصف فريد للمتجر...",
        "errorMessage": "مطلوب"
      },
      "email": {
        "label": "بريدك الإلكتروني",
        "placeholder": "البريد للتواصل...",
        "errorMessageForNull": "مطلوب",
        "errorMessageNoValid": "بريد غير صالح"
      }
    },
    "formSendButton": "تسجيل المتجر",
    "rulesMarket": {
      "iAgree": "أوافق على",
      "rulesPhrase": "قواعد grizzlysms.com"
    },
    "offerAgreement": {
      "iAccept": "أقبل",
      "offerPhrase": "اتفاقية العرض"
    },
    "toastSuccessMessage": "تم إرسال الطلب"
  },
  "bannerForBuyAccounts": {
    "title": "هل تواجه صعوبة في التفعيل عبر SMS؟",
    "subtitle": "اشتري حسابًا جاهزًا، إنه أسهل!",
    "button": "اشتري حسابًا جاهزًا"
  },
  pageRefferalProgram: {
    title: 'البرمجيات',
    totalAmount: 'إجمالي مبيعات ناقص عمولة Grizzly SMS:',
    totalAmountExit: 'المبلغ المسحوب:',
    totalAmountDolg: 'ديون Grizzly SMS:',
    saleTitle: 'المنتج',
    keysInSale: 'المفاتيح المتاحة للبيع',
    keysSold: 'المفاتيح المباعة',
    programAllSum: 'إجمالي مبيعات لكل منتج',
    programSumExtract: 'المبلغ القابل للسحب بعد خصم عمولة Grizzly SMS',
    quantity: 'القطع'
  },
  loading: {
    loading: "جاري التحميل...",
    please_do_not_close_page: "من فضلك لا تغلق الصفحة."
  }
}
